import { render, staticRenderFns } from "./WorkerAssignmentsUpdate.vue?vue&type=template&id=fa729b82&scoped=true&"
import script from "./WorkerAssignmentsUpdate.vue?vue&type=script&lang=js&"
export * from "./WorkerAssignmentsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WorkerAssignmentsUpdate.vue?vue&type=style&index=0&id=fa729b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa729b82",
  null
  
)

export default component.exports